import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit} from '@angular/core';
import {ItemManagerService} from "../../services/itemManager/item-manager.service";
import {Item} from "../../models/Item";
import {ToolsService} from "../../services/toolsService/tools.service";
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
import {PerspectiveService} from "../../services/perspective/perspective.service";
import {isViewMode} from "../../../configs/view_only";
import {debounceTime} from "rxjs/operators";
declare var Yiit;

let highlightTimer = null;

@Component({
  selector: 'app-event-items',
  templateUrl: './event-items.component.html',
  styleUrls: ['./event-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class EventItemsComponent implements OnInit{

  public Yiit = Yiit;
  public isViewMode = isViewMode;
  public itemList = {};
  public groupedList = {};
  public isSidebarOpened:boolean = false;
  public highlightedItemId:any = null;
  public zoom:number = 0;
  public searchInput = '';
  public eventName:string = window['EVENT_CONFIG']['name']; // todo: how to subscribe correctly?
  private filterGroup: any = null;
  private isScrollLoaded = false;
  private hiddenItems = [];

  constructor(
    private itemManager: ItemManagerService, private _elementRef: ElementRef,
    private toolProvider: ToolsService, private cdr: ChangeDetectorRef,
    private view: CesiumAdapterService,
    private perspectiveService: PerspectiveService
  ) {}

  ngOnInit(): void {
    this.itemManager.registerEnvironmentCb(this.setGroupVisibilities.bind(this));
    console.log(' this.itemManager.registerEnvironmentCb');

    this.itemManager.itemAdded.subscribe((item:Item)=>{

      item.getSubject(Item.OBJECT_CLICK).subscribe((isCtrl)=>{
        if (!isCtrl){
          this.highlightedItemId = item.getId();
          let sidebarWasOpened = this.isSidebarOpened;

          this.isSidebarOpened = true;
          this.groupedList[item.getGroup()].isOpenedItem = true;
          this.scrollToHighlightedElm((sidebarWasOpened) ? 1 : 400);
          clearTimeout(highlightTimer);
          highlightTimer = setTimeout(()=>{
            this.highlightedItemId = null;
            this.cdr.markForCheck();
          }, 3000)
        }});

      item.getSubject(Item.SUBJECT_SIDEBAR_VISIBILITY).subscribe((visibility)=>{
        if(visibility){
          this.hiddenItems.includes(item.getId()) ? this.hiddenItems.splice(this.hiddenItems.indexOf(item.getId()), 1) : ''
        }
        else {
          this.hiddenItems.includes(item.getId()) ? '' : this.hiddenItems.push(item.getId());
        }
        this.cdr.markForCheck();
      })

      // item.emitter.subscribe((e)=>{
      //   this.onRemoved(e, item);
      // });
    });


    this.itemManager.itemsList.pipe(debounceTime(500)).subscribe((newList)=>{
      if(Object.keys(this.itemList).length > Object.keys(newList).length){
        this.removeFromGroupedList(newList);
      }

        this.itemList = Object.assign({}, newList);
        this.sortItemsByGroups();
        if (!this.isScrollLoaded){
          this.isScrollLoaded = true;
          document.querySelector('.summary .items-wrapper')['fakeScroll']('.es-scrollbar', true);
        }
    });

    this.view.zoom.pipe(debounceTime(500)).subscribe((level) => {
      this.zoom = level;
      this.cdr.markForCheck();
    });
  }

  public filterGroupsItems(e){
    console.log('e', e);
  }

  // private onRemoved(e, item){
  //   if (e.getEventName() == 'removeObject'){
  //     console.log('removeItem', item);
  //     this.itemManager.removeItem(item, true);
  //     this.cdr.markForCheck();
  //   }
  // }

  private isRemoveGroup(group):boolean{
    for (let i in group){
      if(['isOpenedItem', 'isHiddenObjects', 'isAnotherHiddenObjects'].indexOf(i) == -1){
        return false;
      }
    }
    return true;
  }

  groupKeys(group){
   return Object.keys(group.value);
  }

  isEmptyGroup(group, perspective){
    return Object.keys(group.value)
      .filter( key => {
        if (['isOpenedItem', 'isHiddenObjects', 'isAnotherHiddenObjects'].indexOf(key) >= 0) {
          return false;
        }
        if (this.hiddenItems.length > 0){
          let item = group.value[key];
          if (this.hiddenItems.includes(item.getId())){
            return false;
          }
        }
        if (perspective) {
          let item = group.value[key];
          let tool = item.config.getTool();
          if (tool && tool.hasOwnProperty('perspectives') && tool.perspectives) {
            if (tool.perspectives.indexOf(perspective) >= 0) {
              return true;
            }
          }
          return false;
        }
        return true;
      }).length == 0

  }
  changeGroupsState(val){
    if (val.toString().trim().length > 0){
      for (let i in this.groupedList){
        this.groupedList[i].isOpenedItem = true;
      }
    }
    this.cdr.markForCheck();
  }

  displayItemInGroupList(key){
    return ['isOpenedItem', 'isHiddenObjects', 'isAnotherHiddenObjects'].indexOf(key) == -1;
  }

  isVisibleItem(item:Item){
    return !this.hiddenItems.includes(item.getId());
  }

  private removeFromGroupedList(list){
    for (let i in this.itemList){
      if (!list.hasOwnProperty(i)){
        delete this.groupedList[this.itemList[i].getGroup()][i];
        if (this.isRemoveGroup(this.groupedList[this.itemList[i].getGroup()])){
          delete this.groupedList[this.itemList[i].getGroup()];
        }
      }
    }
  }

  toggleAnotherGroupObjectsVisibility(group, event?){
    let key = group.key;
    let val = group.value;

    if ( this.filterGroup && this.filterGroup.key!=group.key){
      this.toggleAnotherGroupObjectsVisibility(this.filterGroup);
    }

    if (event){
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    val.isAnotherHiddenObjects = !val.isAnotherHiddenObjects;
    for (let _groupName in this.groupedList){
      if (_groupName != key){
        let currentGroup = this.groupedList[_groupName];
        for (let _key in currentGroup){
          let item = currentGroup[_key];
          if (!(item instanceof Item)){
            continue;
          }
          if (val.isAnotherHiddenObjects){
            item.setVisibility(false);
          }
          else{
            item.setVisibility(true);
          }
        }
      }
      else{
        this.filterGroup = group;
      }
    }

    if (!val.isAnotherHiddenObjects){
      this.filterGroup = null;
    }

  }
  getGroupFullName(group){
    return `${group.key} ${this.getGroupLength(group.value)}`
  }

  getGroupLength(values){
    let result = Object.keys(values).filter( key => ['isOpenedItem', 'isHiddenObjects', 'isAnotherHiddenObjects'].indexOf(key) < 0);
    return `(${result.length})`;
  }
  getGroupBackgroundImage(group){
    // let currentTool = this.toolProvider.getToolById(group.value[Object.keys(group.value)[0]].toolId);
    if (!group.value){
      return null;
    }
    return this.toolProvider.getCategoryImageByItem(group.value[Object.keys(group.value)[0]].hasOwnProperty('config') ? group.value[Object.keys(group.value)[0]] : group.value[Object.keys(group.value)[1]]);
  }

  toggleGroupObjectsVisibility(groupObject, event?){
    let group = groupObject.value;
    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    this.itemManager.setGroupVisibility(groupObject.key, 'isHiddenObjects', !group.isHiddenObjects);
    group.isHiddenObjects = !group.isHiddenObjects;
    for (let key in group){
      let item = group[key];
      if (item instanceof Item){
        if (group.isHiddenObjects){
          item.setVisibility(false);
        }
        else{
          item.setVisibility(true);
        }
      }
    }
  }

  private scrollToHighlightedElm(delay?){
    let elm = this._elementRef.nativeElement.querySelector('.es-highlighted');
    if (elm){
      setTimeout(()=>{
        elm.scrollIntoView({behavior: "smooth", block: "center"});
        this.cdr.detectChanges();
      }, delay || 0);
    }
    else{
      setTimeout(()=>{
        this.scrollToHighlightedElm(delay || 0);
        this.cdr.detectChanges();
      }, 50);
    }

  }

  getGroupItems(group){
    return group.value;
  }
  isListEmpty(){
    return Object.keys(this.groupedList).length == 0;
  }


  sortItemsByGroups(){
    for (let itemKey in this.itemList){
      if (this.itemList.hasOwnProperty(itemKey)){
        let currentItem = this.itemList[itemKey];

        if (typeof this.groupedList[currentItem.getGroup()] != 'object'){
          this.groupedList[currentItem.getGroup()] = {}
        }
        this.groupedList[currentItem.getGroup()][itemKey] = currentItem;
      }
    }
    this.cdr.markForCheck();
  }

  toggleSidebar(){
    this.isSidebarOpened = !this.isSidebarOpened;
  }

  setGroupVisibilities(config) {
    let groups = config.groups;
    let items = config.items;
    console.log('items from config', items);
    console.log('items from service', this.itemList);
    for (const [key, items] of Object.entries(this.groupedList)) {
      if (groups.hasOwnProperty(key)) {
        items['isHiddenObjects'] = !groups[key].isHiddenObjects;
        this.toggleGroupObjectsVisibility({key: key, value: items});
      } else {
        items['isHiddenObjects'] = true;
        this.toggleGroupObjectsVisibility({key: key, value: items});
      }
    }
  }

}
